import { Component, ElementRef, TemplateRef, ViewChild, } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { UserProfile } from '../../interfaces/UserProfile';
import { AuthenticationService } from '../../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { DateTime } from 'luxon';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DriverRecordRequestService } from '../../services/driverrecordrequest.service';
import { DriverService } from '../../services/driver.service';
import DriverDTO from 'src/app/interfaces/driverDTO';

@Component({
    selector: 'app-driver-dashboard',
    templateUrl: './driver-dashboard.component.html',
    styleUrls: ['./driver-dashboard.component.scss'],
    standalone: false
})
export class DriverDashboardComponent {

     isLoading = true;
     isSaving = false;
     showWhatIsMonitoring: boolean = false;
     showEnrollMonitoring: boolean = false;
     showOutInMonitoringModal: boolean = false;
     userProfile?: UserProfile;
     isEnrolled: boolean = false;

     @ViewChild('WhatIsMonitoringModal')
     whatIsMonitoringModal!: TemplateRef<any>;

     @ViewChild('EnrollInMonitoringModal')
     enrollInMonitoringModal!: TemplateRef<any>;

     @ViewChild('OptOutInMonitoringModal')
     optOutInMonitoringModal!: TemplateRef<any>;

     @ViewChild('ErrorSavingModal')
     errorSavingModal!: TemplateRef<any>;

     constructor(private authenticationService: AuthenticationService,
          public generalService: GeneralService,
          private _router: Router,
          public modalService: NgbModal,
          public service: DriverRecordRequestService,
          public userService: UserService,
          public driverService: DriverService
     ) {
     }

     ngOnInit(): void {
          this.authenticationService.setDeepLinkResolved(true);
          this.driverService.clearAuthCode();

          this.userProfile = this.authenticationService.getUserProfile();
          const driverProfilePromise = this.service.getDriverByUsername(this.userProfile!.userData!.userName);
          driverProfilePromise.then((response: any) => {
               if (response) {
                    this.driverService.setDriverProfile(response as DriverDTO);
                    this.isEnrolled = (response as DriverDTO).isEnrolledInRecordChangeNotifications?.toString() === "true" ? true : false;
                    this.isLoading = false;
               } else {
                    // Driver profile not found. Logout.  
                    this.authenticationService.logout();
               }
          });
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     showMonitoringModal() {
          this.modalService.open(this.enrollInMonitoringModal, { ariaLabelledBy: 'enrollInMonitoringModalTitle' });
          this.showEnrollMonitoring = true;
     }

     showOptOutInMonitoringModal() {
          this.modalService.open(this.optOutInMonitoringModal, { ariaLabelledBy: 'optOutInMonitoringModalTitle' });
          this.showOutInMonitoringModal = true;
     }

     showMonitoringInfoModal() {
          this.modalService.open(this.whatIsMonitoringModal, { ariaLabelledBy: 'whatIsMonitoringModalTitle' });
     }

     closeModal() {
          this.modalService.dismissAll();
     }

     enrollInMonitoring() {
          this.isSaving = true;
          const savePromise = this.service.updateDriverMonitoringOption('true');
          savePromise.then((response: any) => {
               if (response) {
                    this.isEnrolled = true;
                    this.modalService.dismissAll()
               } else {
                    this.modalService.open(this.errorSavingModal, { ariaLabelledBy: 'errorSavingModalTitle' });
               }
               this.isSaving = false;
          });
     }

     unEnrollInMonitoring() {
          this.isSaving = true;
          const savePromise = this.service.updateDriverMonitoringOption('false');
          savePromise.then((response: any) => {
               if (response) {
                    this.isEnrolled = false;
                    this.modalService.dismissAll()
               } else {
                    this.modalService.open(this.errorSavingModal, { ariaLabelledBy: 'errorSavingModalTitle' });
               }
               this.isSaving = false;
          });
     }

     navigateToReorder() {
          this._router.navigateByUrl('/applicant/2');
     }

     userEmail(): string {
          return this.generalService.maskEmail(this.userProfile!.userData.email);
     }


}
